import Auth from "./Auth";

export default function Signup() {
  return <Auth initialMode="signup" />;
}
